import * as React from 'react';

import { AutomationServerListSection, type NewServerKind } from '@/components/automation-server/AutomationServerListSection';
import { ConnectAutomationServerModal } from '@/components/automation-server/ConnectAutomationServerModal';
import { ProvisionHetznerServerModal } from '@/components/automation-server/ProvisionHetznerServerModal';
import { RequiresClientOrg, useClientOrg } from '@/context/ClientScopeProvider';
import type { AutomationServer } from '@/data/automation-server';
import { ACTIVE_ORG_COOKIE_NAME } from '@/shared/constants';

function Servers() {
  const { orgId, client } = useClientOrg();
  const [showHetzner, setShowHetzner] = React.useState(false);
  const [showBYOS, setShowBYOS] = React.useState(false);
  const [highlighted, setHighlighted] = React.useState<string | null>(null);

  const created = (serverId: string) => {
    setHighlighted(serverId);
    setTimeout(() => setHighlighted(null), 5000);
  };

  const openInClientAoc = (server: AutomationServer) => {
    document.cookie = `${ACTIVE_ORG_COOKIE_NAME}=${orgId}; path=/; max-age=${60 * 60 * 24 * 30}`;
    window.location.assign(`/automation-servers/${server.automation_server_id}`);
  };

  return (
    <div className="space-y-4" data-testid="client-servers-page">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Servers</h2>
        <p className="text-muted-foreground">
          The Bailey servers {client.company_name} runs their automations on. Opening one switches you into their Automation Center.
        </p>
      </div>

      <AutomationServerListSection
        highlightedServerId={highlighted}
        orgId={orgId}
        orgName={client.company_name}
        onOpenDetails={openInClientAoc}
        onNewServer={(kind: NewServerKind) => (kind === 'hetzner' ? setShowHetzner(true) : setShowBYOS(true))}
      />

      <ProvisionHetznerServerModal
        open={showHetzner}
        onOpenChange={setShowHetzner}
        onServerCreated={created}
        orgId={orgId}
      />
      <ConnectAutomationServerModal
        open={showBYOS}
        onOpenChange={setShowBYOS}
        onServerCreated={created}
        orgId={orgId}
      />
    </div>
  );
}

export default function ClientServersPage() {
  return (
    <RequiresClientOrg>
      <Servers />
    </RequiresClientOrg>
  );
}
